import { Observable } from 'rxjs/Observable';
import tmsServiceBackend from '../services/axios/tmsServiceBackend';
import { forEach, clone } from 'lodash-es';
import localStorageUtil from '../services/localStorageUtil/localStorageUtil';
export default {
    exportFile(url: any, filename: any) {
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    },
    showUserWalkthrough(name: any = null) {
        let guideDone = localStorage.getItem('guideDone') == 'true' ? true : false;
        if (guideDone) return true;
        let stageNumber = localStorage.getItem('guideDoneStageNumber');
        if (stageNumber && Number(stageNumber) > 2) return true;
        if (name) {
            (window as any).gotItGettingd(name);
            return true;
        }
        let guideDoneStage = localStorage.getItem('guideDoneStage');
        if (!guideDoneStage) {
            (window as any).gotItGettingd('Dashboard');
            return true;
        }
        if (guideDoneStage) {
            if (guideDoneStage == 'Shipments') (window as any).gotItGettingd(guideDoneStage);
            else (window as any).gotItGettingd(guideDoneStage);
        }
    },

    showUserWalkNext(name: any, _this: any) {
        let guideDone = localStorage.getItem('guideDone') == 'true' ? true : false;
        if (guideDone) return true;
        let stageNumber = localStorage.getItem('guideDoneStageNumber');
        if (stageNumber && Number(stageNumber) > 2) return true;
        if (!guideDone)
            _this.gettingStarted({
                class: `getting-started-with getting-${name}`,
                id: name,
                html: this.guideDoneData()[name],
            });
    },

    guideDoneData() {
        return {
            Dashboard: `<div class="getting-started-rod" ><div class="getting-started-kg" onclick="showGettingbox()"></div><div class="getting-started-box getting-started-Dashboard"><div class="d-flex flex-column"><div class="col-12 mt-3 d-flex justify-content-between align-items-center"><h3>Getting started with UNIS</h3><i class="icon-30 f-18 cursor-p" onclick="hideGettingbox()"></i></div><div class="col-12 mt-4" ><div>This is your dashboard. You’ll find all of  your ongoing shipments, open quotes, and current tasks here.</div></div><div class="col-12 d-flex justify-content-between mt-2">1/6<div><button type="button" class="unis-btn unis-btn-text " style="color: #ffffff"  onclick="gotItGettingd('Requestquote')">Got it</button></div></div></div></div></div>`,
            Requestquote: `<div class="getting-started-rod" ><div class="getting-started-kg" onclick="showGettingbox()"></div><div class="getting-started-box getting-started-Requestquote"><div class="d-flex flex-column"><div class="col-12 mt-3 d-flex justify-content-between align-items-center"><h3>Requesting quotes</h3><i class="icon-30 f-18 cursor-p" onclick="hideGettingbox()"></i></div><div class="col-12 mt-4" ><div>Requesting re-approved quotes is your quickest way to schedule a pickup.</div></div><div class="col-12 d-flex justify-content-between mt-2">2/6<div><button type="button" class="unis-btn unis-btn-text " style="color: #ffffff"  onclick="gotItGettingd('Quotes', true)">Got it</button></div></div></div></div></div>`,
            Ship: `<div class="getting-started-rod" ><div class="getting-started-kg" onclick="showGettingbox()"></div><div class="getting-started-box getting-started-Dashboard"><div class="d-flex flex-column"><div class="col-12 mt-3 d-flex justify-content-between align-items-center"><h3>Getting started with UNIS</h3><i class="icon-30 f-18 cursor-p" onclick="hideGettingbox()"></i></div><div class="col-12 mt-4" >This is your dashboard. You’ll find all of<br> your ongoing shipments, open quotes, and<br> current tasks here.</div><div class="col-12 d-flex justify-content-end mt-2"><div><button type="button" class="unis-btn unis-btn-text " style="color: #ffffff"  onclick="gotItGettingd('Quotes', true)">Got it</button></div></div></div></div></div>`,
            Quotes: `<div class="getting-started-rod" ><div class="getting-started-kg" onclick="showGettingbox()"></div><div class="getting-started-box getting-started-Dashboard"><div class="d-flex flex-column"><div class="col-12 mt-3 d-flex justify-content-between align-items-center"><h3>Viewing quotes</h3><i class="icon-30 f-18 cursor-p" onclick="hideGettingbox()"></i></div><div class="col-12 mt-4" ><div>You can review current and expired quotes here. Open quotes can be used to schedule pickups for 30 days.</div></div><div class="col-12 d-flex justify-content-between mt-2">3/6<div><button type="button" class="unis-btn unis-btn -text " style="color: #ffffff"  onclick="gotItGettingd('QuotesListItem', true)">Got it</button></div></div></div></div></div>`,
            QuotesListItem: `<div class="getting-started-rod" ><div class="getting-started-kg" onclick="showGettingbox()"></div><div class="getting-started-box getting-started-Dashboard"><div class="d-flex flex-column"><div class="col-12 mt-3 d-flex justify-content-between align-items-center"><h3>Scheduling pickups</h3><i class="icon-30 f-18 cursor-p" onclick="hideGettingbox()"></i></div><div class="col-12 mt-4" ><div>Mark the quote you are interested in scheduling a pickup with.</div></div><div class="col-12 d-flex justify-content-between mt-2">4/6<div><button type="button" class="unis-btn unis-btn-text " style="color: #ffffff"  onclick="gotItGettingd('SchedulePickupQuotes')">Got it</button></div></div></div></div></div>`,
            SchedulePickupQuotes: `<div class="getting-started-rod" ><div class="getting-started-kg" onclick="showGettingbox()"></div><div class="getting-started-box getting-started-SchedulePickupQuotes"><div class="d-flex flex-column"><div class="col-12 mt-3 d-flex justify-content-between align-items-center"><h3>Scheduling pickups</h3><i class="icon-30 f-18 cursor-p" onclick="hideGettingbox()"></i></div><div class="col-12 mt-4" ><div>You can then schedule a pickup with this selected quote.</div></div><div class="col-12 d-flex justify-content-between mt-2">5/6<div><button type="button" class="unis-btn unis-btn-text " style="color: #ffffff"  onclick="gotItGettingd('Shipments',true)">Got it</button></div></div></div></div></div>`,
            Shipments: `<div class="getting-started-rod" ><div class="getting-started-kg" onclick="showGettingbox()"></div><div class="getting-started-box getting-started-Dashboard"><div class="d-flex flex-column"><div class="col-12 mt-3 d-flex justify-content-between align-items-center"><h3>Viewing shipments</h3><i class="icon-30 f-18 cursor-p" onclick="hideGettingbox()"></i></div><div class="col-12 mt-4" >You can view all your shipments here. Click on a shipment card to view all details and tracking information.</div><div class="col-12 d-flex justify-content-between mt-2">6/6<div><button type="button" class="unis-btn unis-btn-text " style="color: #ffffff"  onclick="gotItGettingd('ShipmentListItem',true)">Got it</button></div></div></div></div></div>`,
            ShipmentListItem: `<div class="getting-started-rod" ><div class="getting-started-kg" onclick="showGettingbox()"></div><div class="getting-started-box getting-started-Dashboard"><div class="d-flex flex-column"><div class="col-12 mt-3 d-flex justify-content-between align-items-center"><h3>Viewing shipments</h3><i class="icon-30 f-18 cursor-p" onclick="hideGettingbox()"></i></div><div class="col-12 mt-4" >You can view all your shipments here. Click on a shipment card to view all details and tracking information.</div><div class="col-12 d-flex justify-content-between mt-2">6/6<div><button type="button" class="unis-btn unis-btn-text " style="color: #ffffff"  onclick="gotItfinished('finished')">Got it</button></div></div></div></div></div>`,
        };
    },

    isSubject: (subject: any) => {
        return (
            subject && (typeof subject.next === 'function' || typeof subject.onNext === 'function')
        );
    },

    eventToObservable: function(el: any, evtName: Array<any> | string) {
        const evtNames = Array.isArray(evtName) ? evtName : [evtName];
        const obs$ = Observable.create((observer: any) => {
            const eventPairs = evtNames.map(name => {
                const callback = (msg: any) => observer.next({ name, msg });
                el.$on(name, callback);
                return { name, callback };
            });

            return () => {
                // Only remove the specific callback
                eventPairs.forEach(pair => el.$off(pair.name, pair.callback));
            };
        });
        return obs$;
    },

    onSameAsAddress(parame: any) {
        let parames = {
            UserID: localStorage.getItem('UserID'),
            UserToken: localStorage.getItem('UserToken'),
        };
        if (parame.quoteId) {
            parames['quote_id'] = parame.quoteId;
        } else if (parame.orderId) {
            parames['order_id'] = parame.orderId;
        }
        return new Promise((resolve, reject) => {
            tmsServiceBackend.post(`/order/shipper_address`, parames).then(
                (res: any) => {
                    let pickupLocation = res.data.data ? res.data.data : {};
                    let prpickupLocation = clone(pickupLocation);
                    if (parames['quote_id']) {
                        let localStoragPickupAddress = localStorageUtil.getItemFromStorage(
                            'pickupAddress'
                        );
                        if (parame.quoteId == localStoragPickupAddress.quoteId) {
                            prpickupLocation.pickup_location_street =
                                localStoragPickupAddress.location_street;
                        }
                    }
                    resolve({
                        reditCardZip: prpickupLocation.pickup_location_zip,
                        location_state: prpickupLocation.pickup_location_state,
                        location_city: prpickupLocation.pickup_location_city,
                        location_street: prpickupLocation.pickup_location_street,
                        location_street2: prpickupLocation.pickup_location_street2,
                        cloneBillinglocation: clone(prpickupLocation),
                    });
                },
                (err: any) => {
                    reject(err);
                }
            );
        });
    },
    Base64EncodetoString(data: any) {
        return this.encryption(data, this.fiterKey());
    },
    Base64DncodetoString(data: any) {
        return this.decryption(data, this.fiterKey());
    },
    Base64Encode(data: any) {
        let fiterCode: any = {};
        forEach(data, (value: any, key: any) => {
            fiterCode[this.Base64EncodetoString(key)] = this.Base64EncodetoString(value);
        });
        return fiterCode;
    },
    Base64Dncode(data: any) {
        let fiterCode: any = {};
        forEach(data, (value: any, key: any) => {
            fiterCode[this.Base64DncodetoString(key)] = this.Base64DncodetoString(value);
        });
        return fiterCode;
    },
    Base64EncodeForArray(data: any) {
        let fiterData: any = [];
        forEach(data, (value: any) => {
            fiterData.push(this.Base64Encode(value));
        });
        return fiterData;
    },
    Base64DncodeForArray(data: any) {
        let fiterData: any = [];
        forEach(data, (value: any) => {
            fiterData.push(this.Base64Dncode(value));
        });
        return fiterData;
    },

    encryption(str: any, key: any) {
        if (str == null || str == undefined) return str;
        let strpr = typeof str === 'string' ? str : str.toString();
        let l = key.length;
        let a = key.split('');
        let s = '',
            b,
            bl,
            b2,
            b3;
        for (let i = 0; i < strpr.length; i++) {
            b = strpr.charCodeAt(i);
            bl = b % l;
            b = (b - bl) / l;
            b2 = b % l;
            b = (b - b2) / l;
            b3 = b % l;
            s += a[b3] + a[b2] + a[bl];
        }
        return s;
    },

    decryption(str: any, key: any) {
        if (str == null || str == undefined) return str;
        let strpr = typeof str === 'string' ? str : str.toString();
        let l = key.length;
        let b,
            bl,
            b2,
            b3,
            d = 0,
            s;
        s = new window['\x41\x72\x72\x61\x79'](
            window['\x4d\x61\x74\x68']['\x66\x6c\x6f\x6f\x72'](
                strpr['\x6c\x65\x6e\x67\x74\x68'] / 3
            )
        );
        b = s.length;
        for (let i = 0; i < b; i++) {
            bl = key.indexOf(strpr.charAt(d));
            d++;
            b2 = key.indexOf(strpr.charAt(d));
            d++;
            b3 = key.indexOf(strpr.charAt(d));
            d++;
            s[i] = bl * l * l + b2 * l + b3;
        }
        b = window['\x65\x76\x61\x6c']('String.fromCharCode(' + s['\x6a\x6f\x69\x6e'](',') + ')');
        return b;
    },
    fiterKey() {
        return '0l23456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    },
    filterShipmentStage(stage: any, status: any, orderCreatedFromlh: any = null) {
        if (stage == 0 && status == 1) {
            return 'Pickup Created';
        }
        if (stage == 0 && status > 1) {
            return 'Pickup Dispatched';
        }
        if (stage == 2) {
            return 'Pickup Completed';
        }
        if (stage == 1 || stage == 1.1 || stage == 1.3 || stage == 3) {
            return 'In Transit';
        }
        if ((stage == 4 || status == 4.1 || stage == 4.2 || stage == 4.3) && status > 0) {
            if (orderCreatedFromlh == '1') {
                return 'Pending Delivery';
            } else {
                return 'Out for Delivery';
            }
        }
        if (stage == 5 && status > 0) {
            return 'Delivered';
        }
        if (stage == 5 && status == 4) {
            return 'Invoiced';
        } else {
            return 'Empty';
        }
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/shared/util.ts